import { render } from "./Home.vue?vue&type=template&id=6aed1bc8&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=6aed1bc8&scoped=true&lang=css"
import "./Home.vue?vue&type=style&index=1&id=6aed1bc8&lang=scss"
script.render = render
script.__scopeId = "data-v-6aed1bc8"

export default script